<template>
	<div>
		<div class="header-item">
			<h1>SEO</h1>
		</div>

		<div class="white">
			<div class="row">
				<div class="col-20">

					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li><router-link to="/seo/metadata">Metadata</router-link></li>
								<li><router-link to="/seo/headers">Headers</router-link></li>
								<li><router-link to="/seo/ga-code">Ga code</router-link></li>
							</ul>
						</nav>
					</div>

				</div>
			</div>
		</div>

		<router-view></router-view>

	</div>

</template>

<script>

export default {
	name: 'seo'
}
</script>
